import React from "react";

import l from "components/util/l";
import EntityView from "components/util/changes/ChangeView.sub.Entity.view";
import "styles/css/util/Changes.css";

const FILTERS = [
  { key: "added", label: l("Nuevos%DF003") },
  { key: "modified", label: l("Modificados%VG341") },
  { key: "removed", label: l("Eliminados%VG342") },
];

const ChangeViewView = ({
  groups,
  counts,
  isEmpty,
  filter,
  isShowingUnchanged,
  collapsedKeys,
  expandedItemKeys,
  onClickFilter,
  onToggleUnchanged,
  onToggleCollapse,
  onToggleItem,
  onClickCollapseAll,
}) =>
  <div className="change-view">

    <div className="change-view-toolbar">
      <button type="button" className={`change-view-chip ${filter == "all" ? "is-active" : ""}`}
        onClick={() => onClickFilter("all")}>
        {l("Todo%DF004")}
      </button>

      {FILTERS.map((item) => (
        <button key={item.key} type="button"
          className={`change-view-chip ${filter == item.key ? "is-active" : ""}`}
          onClick={() => onClickFilter(item.key)}>
          {item.label} {counts[item.key]}
        </button>
      ))}

      <button type="button" className={`change-view-chip ${isShowingUnchanged ? "is-active" : ""}`}
        onClick={onToggleUnchanged}>
        {l("Sin cambios%PA810")} {counts.unchanged}
      </button>

      <span className="change-view-counts">
        <button type="button" className="change-view-chip" onClick={onClickCollapseAll}>
          {collapsedKeys.length > 0 ? l("Expandir todo%DF005") : l("Contraer todo%DF006")}
        </button>
      </span>
    </div>

    {
      isEmpty || groups.length == 0
        ? <div className="change-view-empty">{l("No hay cambios que mostrar%DF007")}</div>
        : groups.map((group) => (
            <div key={group.key} className="change-view-group">
              <div className="change-view-group-label">
                {group.label} ({group.entities.length})
              </div>
              {group.entities.map((entity) => (
                <EntityView key={entity.key} entity={entity}
                  collapsedKeys={collapsedKeys} expandedItemKeys={expandedItemKeys}
                  onToggleCollapse={onToggleCollapse} onToggleItem={onToggleItem} />
              ))}
            </div>
          ))
    }

  </div>

export default ChangeViewView;
